import React from "react";
import CustomModal from "../../../../../../components/common/modal";
import checkMark from "../../../../../../assets/images/check 1.png";
import "./index.scss";

function CongratulationModal({ show, closeModal }) {
  return (
    <>
      <CustomModal
        show={show}
        handleClose={closeModal}
        className="congratulationModal"
        // title={documentData?.Title}
      >
        <div className="congrats-content">
          <img className="img" src={checkMark} alt="congratulations" />
          <p>Thank you, our Team will get in touch with you </p>
        </div>
      </CustomModal>
    </>
  );
}

export default CongratulationModal;
